module.exports = __webpack_public_path__ + "img/leadsFilteredSpam.698007fa.svg";